import React, { useEffect, useState } from 'react';
import { FormControl, TextField, Grid, Slider, Typography, Card } from '@mui/material';

const SIZE_CONFIG = [
    { name: "small", hw: "2 CPU, 4GB RAM" },
    { name: "medium", hw: "2 CPU, 8GB RAM" },
    { name: "large", hw: "4 CPU, 12GB RAM" },
    { name: "xlarge", hw: "4 CPU, 16GB RAM" }
];

const DEFAULT_INDEX = 2; // "large"

function SelectSize(props) {
    const [currValue, setCurrValue] = useState(0);
    const [currHw, setCurrHw] = useState('');
    const [isCustomizable, setIsCustomizable] = useState(false);

    const rangeHandler = (e, newValue) => {
        const config = SIZE_CONFIG[newValue] || SIZE_CONFIG[DEFAULT_INDEX];
        setCurrValue(newValue);
        setCurrHw(config.hw);

        var tempBaseImage = props.baseImage;
        tempBaseImage.imageSize = config.name;
        props.setBaseImage(tempBaseImage);
    }

    useEffect(() => {
        if (props.baseImage) {
            const index = SIZE_CONFIG.findIndex(s => s.name === props.baseImage.imageSize);
            const validIndex = index !== -1 ? index : DEFAULT_INDEX;
            setCurrValue(validIndex);
            setCurrHw(SIZE_CONFIG[validIndex].hw);

            setIsCustomizable(props.baseImage.imageSizeCustomizable !== "0");
        }
    }, [props.baseImage]);

    if (!props.baseImage.imageName) {
        return null;
    }

    const maxImageSize = 2;

    return (
        <Card sx={{ padding: 3 }}>
            <FormControl fullWidth>
                <Typography variant="h6">Dimensionamento macchine</Typography>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={8}>
                        <Slider
                            disabled={!isCustomizable}
                            min={0}
                            max={maxImageSize}
                            value={currValue}
                            onChange={rangeHandler}
                            aria-labelledby="formLabRequestSize"
                            valueLabelDisplay="off"
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            fullWidth
                            type="text"
                            value={currHw}
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="outlined"
                        />
                    </Grid>
                    {!isCustomizable && (
                        <Grid item xs={12}>
                            <Typography variant="body2" color="textSecondary">
                                L'immagine base selezionata ha un dimensionamento predefinito non modificabile.
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            </FormControl>
            {props.children}
            <br />
        </Card>
    );
}

export default SelectSize;